import * as React from "react";
import {useTranslation} from "react-i18next";
import {getShopId} from "../getShopId";
import styles from "./PaymentMethodsBanner.module.scss";

/**
 * @component
 */
export function PaymentMethodsBanner(): React.ReactElement {
  const {t} = useTranslation();
  const lang = `paymentcard-${document.body.dataset.lang || "en"}`;
  const isDKShop = getShopId() === 100022;

  return (
    <div className={[styles.wrapper, isDKShop ? styles.wrapperSmall : ""].join(" ")}>
      <span className="icon icon-paymentcard-paypal">&#160;</span>
      <span className="icon icon-paymentcard-apple">&#160;</span>
      <span className="icon icon-paymentcard-gpay">&#160;</span>
      <span className={`icon icon-paymentcard-creditcard ${lang}`}>
        <span className="icon__content">{t("general.creditCard")}</span>
      </span>
      {/* no invoice and prepayment for .dk */}
      {!isDKShop && (
        <>
          <span className={`icon icon-paymentcard-prepayment ${lang}`}>
            <span className="icon__content">
              {t("general.prepayment")}
            </span>
          </span>
          <span className={`icon icon-paymentcard-invoice ${lang}`}>
            <span className="icon__content">{t("general.invoice")}</span>
          </span>
        </>
      )}
    </div>
  );
}
